{
  "version": 1,
  "asset_id": "3c4d3b37-018c-4e8c-85ec-97c5a5444d89",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/3c4d3b37-018c-4e8c-85ec-97c5a5444d89/towing-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/3c4d3b37-018c-4e8c-85ec-97c5a5444d89/towing-hero.webp",
  "original_filename": "towing-hero.webp",
  "size": 49912,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:47Z"
}
